import React, { useState } from 'react';
import classNames from 'classnames';
import Avatar from './avatar';
import { FEED_TYPES } from '../../stores/reducers/shots';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveSubTab, setActiveTab, setRightDrawerOpen } from '../../stores/actions/tabs';
import { TABS } from '../../stores/types/tabs';
import { ICONS } from './icon';
import { GreenroomState as GS } from '../../stores/types/types';
import { setSelectedMediaTemplate } from '../../stores/actions/generate-content';
import useShots from '../../contexts/shots/provider';
import { ROOM_STATES } from '../../stores/reducers/settings';
import { MEDIA_SETTINGS_TABS } from "../../stores/reducers/session"
import useMediaItemMemos from '../../hooks/use-media-memos';

interface Props {
	invites: any,
	size: string,
	alignEnd: boolean,
	expandable?: boolean,
	classnames?: string;
	maxBubbles?: number,
	canDisplayHoverIcon?: boolean,
}

export default function AvatarBubbleRow(props: Props) {
	const dispatch = useDispatch();
	const {
		invites = [],
		size = 'thirtytwo',
		alignEnd,
		expandable = false,
		classnames,
		maxBubbles = 3,
		canDisplayHoverIcon = false
	} = props;
	const media = useSelector((state: GS) => state.MediaReducer.media);
	const { use_title_library: useTitleLibrary } = useSelector((state: GS) => state.SettingsReducer.featureFlags);
	const [showAll, setShowAll] = useState(false);
	const [hideShowAll, setHideShowAll] = useState(false);
	const { currentShot	} = useShots();
	const roomState = useSelector((state: GS) => state.MeetingReducer.roomState);

    const {
        currentTemplate,
        currentTemplateMediaItem,
        currentAudioMediaItem,
    } = useMediaItemMemos();

	function hide() {
		setHideShowAll(true);
		setTimeout(() => {
			setShowAll(false);
			setHideShowAll(false);
		}, 300);
	}

	function show() {
		if (expandable) setShowAll(true);
	}

	const avatarOnClick = invites.length === 1 && invites[0].type === 'audio'
		? (e: any) => {
			if (roomState === ROOM_STATES.EDITING && useTitleLibrary) {
				e.stopPropagation(); // prevent parent onClick from firing
	
				if (currentTemplate && !currentTemplate.data?.strict && currentTemplateMediaItem) {
					dispatch(setSelectedMediaTemplate(currentTemplateMediaItem, currentTemplateMediaItem.template_type ?? ''));
					dispatch(setRightDrawerOpen(true));
					dispatch(setActiveTab(TABS.GENERATE_MEDIA_CONTENT));
					dispatch(setActiveSubTab(TABS.GENERATE_MEDIA_CONTENT, MEDIA_SETTINGS_TABS.AUDIO));
				} else {
					const feed = currentShot?.shot_data.shotFeeds.find((x) => x.feedType == FEED_TYPES.MEDIA_AUDIO);
					if (feed) {
						const mediaItem = media.find((m) => m.id === feed.media);
						if (mediaItem) {
							dispatch(setSelectedMediaTemplate(mediaItem, mediaItem.type));
							dispatch(setRightDrawerOpen(true));
							dispatch(setActiveTab(TABS.AUDIO_SETTINGS));
						}
					}
				}
			}
		}
		: undefined;

	const hoverIcon = canDisplayHoverIcon && invites.length === 1 && invites[0].type === 'audio' && roomState === ROOM_STATES.EDITING && useTitleLibrary ? ICONS.EDIT : undefined;

	// find out if invites is array of items with audioOnly attribute
	// let audioOnly = invites && invites.length > 0 && invites[0].audioOnly !== undefined;
	return (
		<div className={classNames('avatar-bubble-row', alignEnd, { 'show-all': showAll }, classnames)} onMouseLeave={hide} data-testid="avatar-bubble-row">
			{invites.length === 0 ? null : invites.map((presenter: any, index: number): JSX.Element | null => {
				if (index < maxBubbles || invites.length === maxBubbles) {
					return (
						<div key={index} className="avatar-container" onClick={avatarOnClick}>
							<Avatar
								user={presenter}
								noBorder={false}
								size={size}
								cursorPointer={invites.length === 1 && presenter.type === 'audio'}
								hoverIcon={hoverIcon}
							/>
						</div>
					);
				}
				return null;
			})}
			{invites.length > maxBubbles && (
				<div className="avatar-container" onClick={show}>
					<div className={classNames('avatar-placeholder', size)} data-testid="avatar-placeholder">
						+{invites.length - maxBubbles}
					</div>
				</div>
			)}
			{showAll && (
				<div className={classNames('show-all-container', { hiding: hideShowAll })}>
					{invites.length === 0 ? null : invites.map((presenter: any, index: number): JSX.Element | undefined => (
						<div key={index} className="avatar-container">
							<Avatar
								user={presenter}
								noBorder={true}
								size={size}
							/>
						</div>
					))}
				</div>
			)}
		</div>
	);
}
